import { useState, useEffect } from "react";
import hero7 from "../../assets/hero.jpg";
import { toast } from 'react-toastify';
import { ts, validatePhoneNumber } from "../utils/metaData";
import { Helmet } from "react-helmet";
import { AiOutlineLoading3Quarters } from 'react-icons/ai';



const cities = [
  "Noida", "Udaipur", "Ajmer", "Pushkar", "Mumbai",
  "Himachal Pradesh", "Uttrakhand", "Indore",
  "Jaisalmer", "Agra", "Mathura", "Jodhpur"
];



export default function Hero() {
  const [cityIndex, setCityIndex] = useState(0);
  const [loading, setLoading] = useState(false)

  const [data, setData] = useState({
    name: "",
    phone: "",
    pickup: "",
    drop: "",
    email: ""
  })


  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.name || !data.phone || !data.drop || !data.pickup || !data.email) {
      toast.error("All fields are required.");
      return;
    }

    if (!validatePhoneNumber(data.phone)) {
      toast.error("Invalid Phone Number");
      return;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        "pid": "INVST"
      }

      const body = JSON.stringify({
        meta: {
          pid: "INVST",
          appName: "bestcab",
          ts: ts(),
          reqAction: "connect",
          location: "N/A",
        },
        pay: {
          phone: data.phone,
          name: data.name,
          pickup: data.pickup,
          drop: data.drop,
          email: data.email
        }
      })
      setLoading(true)  
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/user/bestcab/connect`, {
        method: "POST",
        body: body,
        headers: headers,
      })
      const res = await response.json()
      setLoading(false)
      if (res.statusCode == '000') {
        toast.success(res.message)
      }
      else {
        toast.error(res.message)
      }
      setData({
        name: "",
        phone: "",
        pickup: "",
        drop: "",
        email: ""
      })
    } catch (error) {
      toast.error("Something Went Wrong !");
    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    const interval = setInterval(() => {
      setCityIndex((prevIndex) => (prevIndex + 1) % cities.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>Book a Taxi Instantly | Explore India</title>
        <meta
          name="description"
          content="Book taxis, tour packages, hotel stays, and more with 24/7 support. Explore India with ease!"
        />
        <meta
          name="keywords"
          content="cab service, taxi booking, tour packages, hotel stays, travel India"
        />
        <meta name="author" content="The Best Cab" />
      </Helmet>

      <div className="relative w-full min-h-screen box-border">
        <section className="relative w-full min-h-[100dvh] sm:min-h-[90vh] flex flex-col">
          <img
            src={hero7}
            alt="Hero"
            className="absolute inset-0 w-full h-full object-cover"
            style={{
              filter: "brightness(0.7) contrast(1.2) blur(1px)",
              boxShadow: "inset 0 0 200px rgba(0,0,0,0.9)"
            }}
          />
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-center min-h-[100dvh] text-white px-6 sm:px-8 md:px-20 pt-24 gap-10 md:gap-20">
            <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left">
              <h1 className="text-3xl sm:text-3xl md:text-5xl font-bold">
                Book Cab from Jaipur to{" "}
                <span className="text-pink-400 transition-all duration-500">
                  {cities[cityIndex]}
                </span>
              </h1>
              <p className="text-base sm:text-lg md:text-xl mt-4 max-w-2xl">
                Ride with Comfort, Travel with Trust
              </p>
              <a
                href="/packages"
                className="mt-4 inline-block border border-pink-600 text-pink-600 px-6 py-2 rounded-md hover:bg-pink-600 hover:text-white transition"
              >
                Explore
              </a>
            </div>
            <div className="w-full sm:w-3/4 md:w-1/2 lg:w-1/3 bg-white bg-opacity-30 backdrop-blur-md p-4 sm:p-6 rounded-lg shadow-lg text-black flex flex-col items-center justify-center">
              <h2 className="text-xl font-semibold text-center mb-4 text-white sm:text-2xl">
                Book Your Ride
              </h2>
              <form onSubmit={handleSubmit} className="w-full space-y-4">
                <input
                  type="text"
                  name="name"
                  value={data.name}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
                  placeholder="Name"
                  required
                />
                <input
                  type="text"
                  name="phone"
                  value={data.phone}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
                  placeholder="Phone Number"
                  required
                />
                <input
                  type="mail"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
                  required
                />
                <input
                  type="text"
                  name="pickup"
                  value={data.pickup}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
                  placeholder="Pickup location"
                  required
                />
                <input
                  type="text"
                  name="drop"
                  value={data.drop}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
                  placeholder="Drop location"
                  required
                />
                <button
                  type="submit"
                  className="w-full bg-pink-600 text-white py-2 rounded-lg hover:bg-pink-500 transition flex justify-center items-center gap-2"
                  disabled={loading}
                >
                  {loading ? (
                    <AiOutlineLoading3Quarters className="animate-spin text-xl" />
                  ) : (
                    'Submit'
                  )}
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}